import menu from "./menu"

export default {
    content: {
        menu,
        brand: {
            name: "Sample",
            icon: "security"
        }
    }
}
